import { getCustomerId } from '../storage/customer';

export function identifyCustomer(): boolean {
	const customerId = getCustomerId();
	if (!customerId) return false;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ customerId });
	return true;
}

export function pushFormEvent(formName?: string, eventName?: string, prefix?: string): void {
	const customerId = getCustomerId(prefix);
	if (!customerId) return;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: eventName ?? 'formSubmitted',
		formName: formName ?? 'registration-form-submit',
		customerId,
	});
}
